<template>
  <div class="information--bar" :style="minHeight" ref="root">
    <div class="summary" v-if="!detailActive && !deactivating">
      <div class="content">
        <h3 :style="contentColor">{{informationItem.title}}</h3>
        <div class="text" :style="contentColor" v-html="informationItem.content"/>
        <div class="arrow-icon"><Arrow/></div>
      </div>
      <div class="image" v-if="informationItem.image[0].imageUrl">
        <img :src="imageUrl(informationItem.image[0])" :alt="informationItem.title"/>
      </div>
      <BottomBackground/>
    </div>
    <div class="fold--left"></div>
    <div class="fold--right"></div>
    <transition name="detail-open" v-on:enter="detailEnter" v-on:leave="detailLeave">
      <div class="detail fold--content" v-if="detailActive && informationItem.detail" :style="overlayStyle(informationItem)">
        <div class="close"><CloseIcon/></div>
        <div class="content" ref="content" v-html="informationItem.detail"/>
      </div>
    </transition>
  </div>
</template>

<script>
import BottomBackground from "../assets/svg/information-bar-background.svg"
import CloseIcon from "../assets/svg/close.svg"
import Arrow from '@/assets/svg/arrow.svg'

import { developmentFixImageUrls } from '../helpers'

export default {
  name: "InformationBars",
  components: {
    BottomBackground,
    CloseIcon,
    Arrow
  },
  props: {
    informationItem: {
      type: Object,
      default: function() {
        return {};
      }
    },
    detailActive: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    deactivating: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  data() {
    return {
      activeItem: {},
      errors: [],
      isMounted: false
    };
  },
  created() {
    window.addEventListener("resize", this.resize);
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  mounted() {
    this.init();
  },
  methods: {
    resize() {},
    init() {
      this.isMounted = true;
      let icons = this.$refs.root.querySelectorAll('.arrow-icon');

      icons.forEach((i) => {
        let paths = i.querySelectorAll('path');
        paths.forEach((p) => {
          p.style.fill =  this.informationItem.contentColor ? this.informationItem.contentColor : '#ffffff';
        })
      })
    },
    detailEnter: function(el, done) {
      let c = this;
      setTimeout(() => {
        el.parentNode.classList.add('is-open'); done()
      }, 300);
      setTimeout(() => {
        el.classList.add('active'); 
        let minHeight = el.parentNode.style.minHeight ? el.parentNode.style.minHeight : '200px';
        minHeight = minHeight.replace('px', '');
        if (c.$refs.content) {
          minHeight = Math.max(minHeight, c.$refs.content.offsetHeight);
        }
        el.parentNode.style.minHeight = minHeight + 'px';
        
        done()
      }, 700);
      done();
    },
    detailLeave: function(el, done) {
      el.parentNode.classList.remove('is-open');
      el.classList.remove('active');
      setTimeout(() => {done()}, 1000);

    },
    overlayStyle(item) {
      return {
        color: item.overlayColor ? item.overlayColor : '#1b3473'
      }
    },
    contentColor() {
      return {
        color: this.informationItem.contentColor ? this.informationItem.contentColor : '#ffffff'
      }
    },
    imageUrl(image) {
      //Only in development
      if (process.env.NODE_ENV == 'development') {
        return developmentFixImageUrls(image.imageUrl);
      }
      return image.imageUrl;
    }
    
  },
  computed: {
    minHeight() {
      //Ensure the card doesn't fold back down to less than the current height
      if (this.isMounted) {
        return {minHeight: this.$refs.root.offsetHeight + 'px'}
      } else {
        return {};
      }
    }
  },
  ready: function() {
    window.addEventListener("resize", this.chartSize);
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.chartSize);
  }
};
</script>


<style scoped lang="scss">
img {
  width: 100%;
}
.information--bar {
  overflow: hidden;
  position: relative;
}
.information--bar, .detail {
  position: relative;
  width: 100%;
  height: 100%;
}
.summary {
  visibility: visible;
  padding-bottom: 200px;
  svg {
    position: absolute;
    width: 100%;
    bottom: 0;
  }
  .arrow-icon svg {
    position: relative;
    width: 20px;
    bottom: unset;
  }
}
.content {
  padding: 25px;
}
.image {
  margin-bottom: 25px;
}
.fold--left, .fold--right {
  overflow: hidden;
  position: relative;
  perspective: 2000px;
  width: 50%;
  height: 100%;
  float: left;
  display: block;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    backface-visibility: hidden;
    transition: transform .5s .4s,background-color .5s .4s;
  }
}
.fold--left {
  perspective-origin: 100% 50%;
  &::after {
    transform: translateX(100%) rotateY(90deg);
    transform-origin: left center;
    background-color: #f9fafa;
  }
}
.fold--right {
  perspective-origin: 100% 50%;
  &::after {
    transform: translateX(-100%) rotateY(-90deg);
    transform-origin: right center;
    background-color: #c0c3c3;
  }
}
.fold--content {
  padding: 25px;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: none;
  background-color: transparent;
  visibility: hidden;
  transition: visibility 0s 0.4s, background-color 0s 2s;
  &.active {
    visibility: visible;
    display: block;
    background-color: #f9fafa;
    transition: visibility 0s 0s;
  }
}
.is-open {
  .fold--right, .fold--left {
    &::after {
      transform: translateX(0);
      transition: transform .5s 0.1s,background-color .5s 0.4s;
    }
  }
  .fold--right {
    &::after {
      background-color: #f9fafa;
    }
  }
  .summary {
    visibility: hidden;
    transition: visibility 0s 0.5s;
  }
}
.close {
  position: absolute;
  width: 50px;
  height: 50px;
  right: 25px;
  top: 10px;
  cursor: pointer;
  svg {
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 480px) {
  .information--bars {
    flex-wrap: wrap;
    .information--bars__header, .information--bars {
      width: 100%;
    }
  }
  .arrow {
    transform: rotate(90deg);
  }
}
</style>